import {useBreakpointValue} from 'native-base';

/**
 *  Custom hook to provide a universal isDesktop value
 *  so we don;t have to change values in different places
 *  in case we decide to change the breakpoints
 * @returns boolean
 */
export const useIsMD = (): boolean =>
  useBreakpointValue({
    base: false,
    md: true,
  });
